module.exports = __webpack_public_path__ + "static/logo-2cddfd2286aba2f2ab6f1a02abb55169.png";